<div id="wrapper" [style.height]="(((filteredPolicies$ | async)?.length ?? 0) === 0) ? 'calc(100% - 98px)' : 'auto'">

  <!--    entry fields for new policy-->
  <div class="container">
    <mat-form-field appearance="outline" class="search-form-field" color="accent">
      <mat-label>Search by id</mat-label>
      <input (input)="onSearch()" [(ngModel)]="searchText" matInput>
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>

    <button (click)="onCreate($event)" color="accent" mat-flat-button>
      <mat-icon>add_circle</mat-icon>
      Create policy
    </button>

  </div>

  <ng-container *ngIf="filteredPolicies$ | async as policies">
    <div *ngIf="policies.length === 0" class="empty-wrapper">
      <div class="no-assets-message">
        <mat-icon style="font-size: 64px; width: 64px; height: 64px;">policy</mat-icon>
        <h2>No policies available</h2>
        <p>The connector doesn't have any policies.</p>
        <p>Create a new policy to get started.</p>
      </div>
    </div>
  </ng-container>


  <ng-container *ngIf="filteredPolicies$ | async as policyDefinitions">
  <div class="cards-grid">
    <mat-card *ngFor="let policyDef of policyDefinitions" class="policy-card">
      <mat-card-header>
        <mat-icon mat-card-avatar>policy</mat-icon>
        <mat-card-title><span>{{policyDef.id}}</span></mat-card-title>
      </mat-card-header>

      <mat-divider class="asset-header-divider"></mat-divider>

      <mat-card-content>

        <!-- <div class="asset-property-row">
          <div class="asset-property-top">
            <mat-icon>trip_origin</mat-icon>
            <div class="asset-property-header">Assigner</div>
          </div>
          <div class="asset-property-value">{{policyDef.policy.assigner || 'n/a'}}</div>
        </div> -->

        <!-- <div class="asset-property-row">
          <div class="asset-property-top">
            <mat-icon>adjust</mat-icon>
            <div class="asset-property-header">Assignee</div>
          </div>
          <div class="asset-property-value">{{policyDef.policy.assignee || 'n/a'}}</div>
        </div> -->

        <div class="asset-property-row">
          <div class="asset-property-top">
            <mat-icon>category</mat-icon>
            <div class="asset-property-header">Type</div>
          </div>
          <div class="asset-property-value">{{policyDef['@type'] ? (policyDef['@type']) : 'n/a'}}</div>
        </div>

        <div class="asset-property-row">
          <div class="asset-property-top">
            <mat-icon>schedule</mat-icon>
            <div class="asset-property-header">Created At</div>
          </div>
          <div class="asset-property-value">{{policyDef['createdAt'] ? (policyDef['createdAt'] | date:'dd/MM/yyyy HH:mm:ss') : 'n/a'}}</div>
        </div>

        <!-- Permissions-->
        <policy-rules [rules]="policyDef.policy.permissions" [title]="'Permissions'"></policy-rules>

        <!-- Obligations-->
        <policy-rules [rules]="policyDef.policy.obligations" [title]="'Obligations'"></policy-rules>

        <!-- Prohibitions-->
        <policy-rules [rules]="policyDef.policy.prohibitions" [title]="'Prohibitions'"></policy-rules>

      </mat-card-content>

      <mat-card-footer class="policy-card-footer">
        <button
          (click)="delete(policyDef)"
          mat-stroked-button
          color="warn"
          class="card-footer-button">
          <mat-icon>delete</mat-icon>
          Delete
        </button>
      </mat-card-footer>
    </mat-card>
  </div>
  <mat-paginator *ngIf="policyDefinitions?.length" [length]="policyDefinitions?.length" hidePageSize="true" pageSize="10"></mat-paginator>
  </ng-container>
</div>
